export default function(url) {
	var ajax = new XMLHttpRequest();
	ajax.open('GET', url, true);
	ajax.send();
	ajax.onload = function(e) {
		var div = document.createElement('div');
		div.innerHTML = ajax.responseText;
		document.body.insertBefore(div, document.body.childNodes[0]);
	}
};


// WEBPACK FOOTER //
// ./js/Util/InjectSVGSprite.js